/**
 * Available measurement types
 */

export enum ResultDataPointTypes {
  Complete = 121049,
  Partial = 121050,
}
export enum MeasurementType {
  /** TEV */
  TEV = "$TEV",

  /** Ultrasonic */
  Ultra = "$ULTRA",

  /** Cable PD */
  CablePD = "$CABLE_PD",

  /** UHF */
  UHF = "$UHF",

  /** VPIS */
  VPIS = "$VPIS",
}

/**
 * The access location for the component of the panel that the measurement must be taken against
 */
export enum AccessLocation {
  /** Front */
  Front = "$FRONT",

  /** Back */
  Back = "$BACK",

  /** Other */
  Other = "$OTHER",
}

/**
 * The sub component of the panel that the measurement must be taken against
 */
export enum MeasurementComponent {
  /** The cables*/
  Cables = "$CABLES",

  /** The cables for a transformer */
  PrimaryCables = "$PRIMARY_CABLES",

  /** The primary cable box */
  PrimaryCableBox = "$PRIMARY_CABLE_BOX",

  /** The primary bushing */
  PrimaryBushing = "$PRIMARY_BUSHING",

  /** The main tank */
  MainTank = "$MAIN_TANK",

  /** The tap changer */
  TapChanger = "$TAP_CHANGER",

  /** The secondary bushing 1 */
  SecondaryBushing1 = "$SECONDARY_1_BUSHING",

  /** The secondary cables 1 */
  SecondaryCables1 = "$SECONDARY_1_CABLES",

  /** The secondary cable box 1 */
  SecondaryCableBox1 = "$SECONDARY_1_CABLE_BOX",

  /** The secondary bushing 2 */
  SecondaryBushing2 = "$SECONDARY_2_BUSHING",

  /** The secondary cable box 2 */
  SecondaryCableBox2 = "$SECONDARY_2_CABLE_BOX",

  /** The secondary cables 2 */
  SecondaryCables2 = "$SECONDARY_2_CABLES",

  /** The cable box */
  CableBox = "$CABLE_BOX",

  /** The ct chamber */
  CTChamber = "$CT_CHAMBER",

  /** The vt chamber */
  VTChamber = "$VT_CHAMBER",

  /** The upper busbars */
  UpperBusbars = "$UPPER_BUSBARS",

  /** The lower busbars */
  LowerBusbars = "$LOWER_BUSBARS",

  /** The spouts */
  Spouts = "$SPOUTS",

  /** The circuit breaker */
  CircuitBreaker = "$CIRCUIT_BREAKER",

  /** The overhead switch 1 */
  OverheadSwitch1 = "$OVERHEAD_SWITCH_1",

  /** The overhead switch 2 */
  OverheadSwitch2 = "$OVERHEAD_SWITCH_2",

  /** The voltage transformer */
  VoltageTransformer = "$VOLTAGE_TRANSFORMER",

  /** The current transformer */
  CurrentTransformer = "$CURRENT_TRANSFORMER",

  /** The busbar section 1 */
  BusbarSection1 = "$BUSBAR_SECTION_1",

  /** The busbar section 2 */
  BusbarSection2 = "$BUSBAR_SECTION_2",

  /** The lightning arrester */
  LightningArrester = "$LIGHTNING_ARRESTER",

  /** The Incomer Cable */
  IncomerCable = "$INCOMER_CABLE",

  /** Circuit Breaker Expanded */
  CircuitBreakerExpanded = "$CIRCUIT_BREAKER_EXPANDED",

  /** The rear lower section */
  RearLower = "$REAR_LOWER",

  /** The rear middle section */
  RearMiddle = "$REAR_MIDDLE",

  /** The rear upper section */
  RearUpper = "$REAR_UPPER",

  /** The front lower section */
  FrontLower = "$FRONT_LOWER",

  /** The front middle section */
  FrontMiddle = "$FRONT_MIDDLE",

  /** The front upper section */
  FrontUpper = "$FRONT_UPPER",

  /** The disconnector switch 1 */
  DisconnectorSwitch1 = "$DISCONNECTOR_SWITCH_1",

  /** The disconnector switch 2 */
  DisconnectorSwitch2 = "$DISCONNECTOR_SWITCH_2",

  /** The gas insulated line */
  GasInsulatedLine = "$GAS_INSULATED_LINE",

  /** The earthing switch */
  EarthingSwitch = "$EARTHING_SWITCH",

  /** The current transformer 1 */
  CurrentTransformer1 = "$CURRENT_TRANSFORMER_1",

  /** The current transformer 2 */
  CurrentTransformer2 = "$CURRENT_TRANSFORMER_2",

  /** The busbar 1 */
  Busbar1 = "$BUSBAR_1",

  /** The busbar 2 */
  Busbar2 = "$BUSBAR_2",
}

/**
 * Possible switch positions.
 */
export enum SwitchPosition {
  /** Open. */
  Open = "$POS_OPEN",

  /** Closed. */
  Closed = "$POS_CLOSED",

  /** Absent. */
  Absent = "$POS_ABSENT",

  /** Earthed. */
  Earthed = "$POS_EARTHED",

  /** NA. */
  NA = "$POS_NA",
}

/**
 * The sublocation of the asset that describes where the measurement should be taken.
 */
export enum SubLocation {
  /** Measurement to a particular sub-location is not required. */
  None = "$NONE",

  /** Cable 1, Phase 1 */
  P1_C1 = "$P1_C1",

  /** Cable 1, Phase 2 */
  P2_C1 = "$P2_C1",

  /** Cable 1, Phase 3 */
  P3_C1 = "$P3_C1",

  /** Cable 2, Phase 1 */
  P1_C2 = "$P1_C2",

  /** Cable 2, Phase 2 */
  P2_C2 = "$P2_C2",

  /** Cable 2, Phase 3 */
  P3_C2 = "$P3_C2",

  /** Cable 3, Phase 1 */
  P1_C3 = "$P1_C3",

  /** Cable 3, Phase 2 */
  P2_C3 = "$P2_C3",

  /** Cable 3, Phase 3 */
  P3_C3 = "$P3_C3",

  /** Cable 4, Phase 1 */
  P1_C4 = "$P1_C4",

  /** Cable 4, Phase 2 */
  P2_C4 = "$P2_C4",

  /** Cable 4, Phase 3 */
  P3_C4 = "$P3_C4",

  /** Cable 5, Phase 1 */
  P1_C5 = "$P1_C5",

  /** Cable 5, Phase 2 */
  P2_C5 = "$P2_C5",

  /** Cable 5, Phase 3 */
  P3_C5 = "$P3_C5",

  /** Cable 6, Phase 1 */
  P1_C6 = "$P1_C6",

  /** Cable 6, Phase 2 */
  P2_C6 = "$P2_C6",

  /** Cable 6, Phase 3 */
  P3_C6 = "$P3_C6",

  /** Upper Left */
  SUB_LOC_UPPER_LEFT = "$SUB_LOC_UPPER_LEFT",

  /** Upper Centre */
  SUB_LOC_UPPER_CENTRE = "$SUB_LOC_UPPER_CENTRE",

  /** Upper Right */
  SUB_LOC_UPPER_RIGHT = "$SUB_LOC_UPPER_RIGHT",

  /** Centre Left */
  SUB_LOC_CENTRE_LEFT = "$SUB_LOC_CENTRE_LEFT",

  /** Centre Right */
  SUB_LOC_CENTRE_RIGHT = "$SUB_LOC_CENTRE_RIGHT",

  /** Lower Left */
  SUB_LOC_LOWER_LEFT = "$SUB_LOC_LOWER_LEFT",

  /** Lower Centre */
  SUB_LOC_LOWER_CENTRE = "$SUB_LOC_LOWER_CENTRE",

  /** Lower Right */
  SUB_LOC_LOWER_RIGHT = "$SUB_LOC_LOWER_RIGHT",

  /** Left */
  SUB_LOC_LEFT = "$SUB_LOC_LEFT",

  /** Centre */
  SUB_LOC_CENTRE = "$SUB_LOC_CENTRE",

  /** Right */
  SUB_LOC_RIGHT = "$SUB_LOC_RIGHT",

  /** Conductor Connection */
  SUB_LOC_CONDUCTOR_CONNECTION_L1 = "$CONDUCTOR_CONNECTION_L1",
  SUB_LOC_CONDUCTOR_CONNECTION_L2 = "$CONDUCTOR_CONNECTION_L2",
  SUB_LOC_CONDUCTOR_CONNECTION_L3 = "$CONDUCTOR_CONNECTION_L3",

  /** Conductor Bushing */
  SUB_LOC_BUSHING_L1 = "$INSULATOR_BUSHING_L1",
  SUB_LOC_BUSHING_L2 = "$INSULATOR_BUSHING_L2",
  SUB_LOC_BUSHING_L3 = "$INSULATOR_BUSHING_L3",

  /** Structure */
  SUB_LOC_STRUCTURE_L1 = "$STRUCTURE_L1",
  SUB_LOC_STRUCTURE_L2 = "$STRUCTURE_L2",
  SUB_LOC_STRUCTURE_L3 = "$STRUCTURE_L3",

  /** Tank */
  SUB_LOC_TANK_L1 = "$TANK_L1",
  SUB_LOC_TANK_L2 = "$TANK_L2",
  SUB_LOC_TANK_L3 = "$TANK_L3",
}

/**
 * The type used for phase reference
 */
export enum PhaseReferenceType {
  /**  Photo sensor (typically via the substation lights) */
  Photo = "$PHASE_REF_PHOTO",

  /** Electric Field */
  ElectricField = "$PHASE_REF_EFIELD",

  /** Magnetic Field */
  MagneticField = "$PHASE_REF_HFIELD",

  /** Manual (entered via user) */
  Manual = "$PHASE_REF_MANUAL",

  /** Digital */
  Digital = "$PHASE_REF_DIGITAL",

  /** Smart Auxillary Port */
  AuxillaryPort = "$PHASE_REFAUX_PORT",

  /** Wireless */
  Wireless = "$PHASE_REF_WIRELESS",

  /** SmartIO */
  SmartIO = "$PHASE_REF_SMARTIO",
}

/**
 * The type of filter used.
 */
export enum CablePDFilterName {
  /* All (No Filter) */
  All = "$FILT_ALL",

  /* A 500kHz Filter */
  Filter500KHz = "$FILT_500k",

  /* A 1.8MHz Filter*/
  Filter1_8MHz = "$FILT_1_8M",
}

/**
 * A human readable interpretation of the Tev measurement.
 */
export enum TEVInterpretation {
  /** No Concern */
  TEVINT_NO_CONCERN = "$TEVINT_NO_CONCERN",

  /** Possible low level internal partial discharge - no immediate concern */
  TEVINT_LOWLEVEL_PD = "$TEVINT_LOWLEVEL_PD",

  /** Possible surface discharge - check ultrasonics */
  TEVINT_SURF_DISCHARGE = "$TEVINT_SURF_DISCHARGE",

  /** High pulses per cycle - noise likely */
  TEVINT_HIGHPPC_NOISE = "$TEVINT_HIGHPPC_NOISE",

  /** No Concern - low pulses per cycle */
  TEVINT_NO_CONCERN_LOW_PPC = "$TEVINT_NO_CONCERN_LOW_PPC",

  /** Possible medium level internal partial discharge */
  TEVINT_POSS_MED_INT_PD = "$TEVINT_POSS_MED_INT_PD",

  /** Likely medium level internal partial discharge */
  TEVINT_LIKE_MED_INT_PD = "$TEVINT_LIKE_MED_INT_PD",

  /** Possible high level internal partial discharge */
  TEVINT_POSS_HIGH_INT_PD = "$TEVINT_POSS_HIGH_INT_PD",

  /** Likely high level internal partial discharge */
  TEVINT_LIKE_HIGH_INT_PD = "$TEVINT_LIKE_HIGH_INT_PD",

  /** Likely floating metalwork or poor connections */
  TEVINT_FLOAT_METAL = "$TEVINT_FLOAT_METAL",

  /** High noise level: measurement invalid */
  TEVINT_BACKGROUND_NOISE = "$TEVINT_BACKGROUND_NOISE",
}

/**
 * A human readable interpretation of the ultrasonic result.
 */
export enum UltraSonicClassification {
  /**  Noise */
  Noise = "$ULTRA_NOISE",

  /**  PDDetected */
  PDDetected = "$ULTRA_PD",

  /**  The measurement was invalid */
  Invalid = "$ULTRA_INVALID",
}

/**
 * The accessory that should be used when taking the measurement.
 */
export enum MeasurementAccessory {
  /** Internal ultrasonic sensor */
  ULTRA_INT = "$ULTRA_INT",

  /** Flexi ultrasonic sensor */
  ULTRA_FLEX = "$ULTRA_FLEX",

  /** Ultrasonic contact probe */
  ULTRA_CONT = "$ULTRA_CONT",

  /** Ultrasonic parabolic dish */
  ULTRA_DISH = "$ULTRA_DISH",

  /** The ultra bolt */
  ULTRA_BOLT = "$ULTRA_BOLT",
}

export enum InsulationType {
  Air = "$INSU_AIR",
  Oil = "$INSU_OIL",
  Compound = "$INSU_COMP",
  SF6 = "$INSU_SF6",
  PILC = "$INSU_PILC",
  XLPE = "$INSU_XLPE",
  EPR = "$INSU_EPR",
}

export enum RAGStatus {
  Red = "Red",
  Amber = "Amber",
  Green = "Green",

  None = "None",
}

export enum ReportStatuses {
  NotViewed = "NotViewed",
  Viewed = "Viewed",
  Analysed = "Analysed",
  Generated = "Generated",
}
